import React, { useContext } from "react";
import AppBar from "./AppBarNotAuth";
import MaintenanceScreen from "../components/MaintenanceScreen";
import { BackendInfoContext } from "../features/backend-info-context/context";
import Main from "../Main";

const MainPageMaintenance = () => {
  const status = false;
  const { maintenance, dbVersionMismatch } = useContext(BackendInfoContext);
  if (dbVersionMismatch)
    return (
      <>
        <AppBar disabled={status ? false : true} />
        <MaintenanceScreen
          text={
            "We cannot connect to the backend because there is a DB mismatch. Most likely an upgrade is in progress. Please try again later. If issue persists, contact support in SNOW"
          }
          title={"DB Version mismatch"}
        />
      </>
    );
  if (maintenance)
    return (
      <>
        <AppBar disabled={status ? false : true} />
        <MaintenanceScreen
          text={"The application is currently undergoing scheduled maintenance. We should be back shortly"}
          title={"This application is under maintenance"}
        />
      </>
    );
  return <Main />;
};
export default MainPageMaintenance;
